// extracted by mini-css-extract-plugin
export default {"monitoringCharacteristics__title":"styles_monitoring-characteristics__title__ZjrFt"};